//
// Scroll to target
// --------------------------------------------------
// Used to smooth scroll to target, able to set offset if required (e.g. navigation is fixed)

export function scrollToTarget(element){
    let offset = 128;
    const smToLgMediaQuery = window.matchMedia('(max-width: 1023px)');
    const smMediaQuery = window.matchMedia('(max-width: 639px)');

    if (smToLgMediaQuery.matches) {
        offset = 128;
    }

    if (smMediaQuery.matches) {
        offset = 128;
    }

    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.scrollY - offset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}